export enum Type {
  ABKUERZUNG = 'ABKUERZUNG',
  ADJEKTIV = 'ADJEKTIV',
  ADVERB = 'ADVERB',
  ARTIKELWORT = 'ARTIKELWORT',
  EIGENNAME = 'EIGENNAME',
  KONNEKTOR = 'KONNEKTOR',
  MODALWORT = 'MODALWORT',
  NOMEN = 'NOMEN',
  PARTIKEL = 'PARTIKEL',
  PRAEPOSITION = 'PRAEPOSITION',
  PRONOMEN = 'PRONOMEN',
  SUFFIX = 'SUFFIX',
  VERB = 'VERB',
  WWORT = 'WWORT',
  ZAHLWORT = 'ZAHLWORT'
}
